import React, { useState, useEffect } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import './Auth.css';
import { API_BASE } from '../config/api';
import { jsonHeaders, parseApiError } from '../utils/apiClient';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    token: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [fromEmailLink, setFromEmailLink] = useState(false);

  useEffect(() => {
    const email = searchParams.get('email') || '';
    const token = searchParams.get('token') || '';
    setFormData(prev => ({ ...prev, email, token }));
    setFromEmailLink(Boolean(email && token));
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.newPassword !== formData.confirmPassword) {
      setMessage('Passwords do not match');
      return;
    }

    if (!formData.email || !formData.token) {
      setMessage('Missing reset link details. Please use the link from your email or enter your email and reset code.');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const params = new URLSearchParams({
        email: formData.email,
        token: formData.token,
        newPassword: formData.newPassword,
      });

      const response = await fetch(`${API_BASE}/auth/reset-password?${params.toString()}`, {
        method: 'POST',
        headers: jsonHeaders,
      });

      if (response.ok) {
        setMessage('Password reset successful! Redirecting to login...');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setMessage(await parseApiError(response));
      }
    } catch (error) {
      setMessage('Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <Navigation />
      <div className="auth-container">
        <form onSubmit={handleSubmit} className="auth-form">
          <h2>Reset Password</h2>
          <p>
            {fromEmailLink
              ? 'Choose a new password for your account.'
              : 'Enter your email, reset code, and new password.'}
          </p>

          {!fromEmailLink && (
            <>
              <input
                type="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
              />

              <input
                type="text"
                placeholder="Reset Code"
                value={formData.token}
                onChange={(e) => setFormData({ ...formData, token: e.target.value.toUpperCase() })}
                required
                maxLength={10}
              />
            </>
          )}

          {fromEmailLink && (
            <p style={{ margin: 0, color: '#64748b', fontSize: '0.95rem' }}>
              Resetting password for <strong>{formData.email}</strong>
            </p>
          )}

          <input
            type="password"
            placeholder="New Password"
            value={formData.newPassword}
            onChange={(e) => setFormData({ ...formData, newPassword: e.target.value })}
            required
          />

          <input
            type="password"
            placeholder="Confirm Password"
            value={formData.confirmPassword}
            onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
            required
          />

          <button type="submit" disabled={loading}>
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>

          {message && (
            <p className={`message ${message.includes('successful') ? 'success' : 'error'}`}>
              {message}
            </p>
          )}

          <p className="auth-toggle">
            Remember your password?
            <Link to="/login" className="toggle-link">
              Login here
            </Link>
          </p>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default ResetPassword;
